// extracted by mini-css-extract-plugin
module.exports = {"confirmContainer":"confirm_confirmContainer__2lL8o","label":"confirm_label__3d-jV","input":"confirm_input__wrWw-"};